import _styled from "@emotion/styled/base";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useUnmountEffect } from '@react-hookz/web';
import { noop } from 'lodash';
import { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Sentinel } from '../../../primitives/Sticky/Element/components/Sentinel.js';
import { Sticky } from '../../../primitives/Sticky/Element/components/Sticky.js';
import { getRootMargin } from '../../../primitives/Sticky/Element/utils.js';
import { ANCHOR_TOP } from '../../../primitives/Sticky/models.js';
// @TODO
// - handle anchors other than "top"
// - non document viewport
// - horizontal scrolling (or custom overflow in general)
// - nesting (ie. multiple roots)
// - multiple elements
// - unit tests (how?)
const ElementComponent = ({
  enabled = true,
  anchor = ANCHOR_TOP,
  anchorOffset = 0,
  children,
  onChange = noop,
  ...restProps
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const sentinel = useInView({
    skip: !enabled,
    fallbackInView: false,
    rootMargin: getRootMargin(anchor, anchorOffset),
    onChange: inView => {
      const isStuckNow = !inView;
      setIsSticky(isStuckNow);
      onChange(isStuckNow);
    }
  });
  useUnmountEffect(() => {
    onChange(false);
  });
  if (!enabled) {
    return children;
  }
  return _jsxs(_Fragment, {
    children: [_jsx(Sticky, {
      ...restProps,
      anchor: anchor,
      anchorOffset: anchorOffset,
      "data-is-sticky": isSticky ? true : undefined,
      children: children
    }), _jsx(Sentinel, {
      ref: sentinel.ref,
      anchor: "top"
    })]
  });
};
/**
 * @deprecated use useStickyElement() hook instead
 */
export const Element = /*#__PURE__*/_styled(ElementComponent, {
  label: 'StickyElement',
  target: "e1fyclye0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");